import { CSSProperties, useCallback, useContext, useEffect, useMemo, VFC } from 'react'
import { ConnectedTable, RowInstance, TableProvider } from '@panwds/react-table'
import MappingCell from './MappingCell'
import { ARRAY } from '../../../../../common/utils/Utils'
import V5TableWrapper from '../../../../../common/components/table/V5TableWrapper'
import GlobalContext from '../../../../../common/context/GlobalContext'

const FederationMappingTable: VFC<{
  data: any[],
  enableRowSelect?: boolean,
  border?: boolean,
  tableInstanceRef?: any,
  tableRef?: any,
  domain: any,
  style?: CSSProperties
}> = ({
  data = [],
  enableRowSelect = false,
  border = true,
  tableInstanceRef,
  tableRef,
  domain,
  style
}) => {

  const { iamReducer } = useContext(GlobalContext)
  const { federationMappingsMap } = iamReducer

  const onSelect = useCallback((row) => {
    const updateChildren: (subRows: any, isSelected: any) => any = (subRows, isSelected) => {
      subRows.forEach((row: any) => {
        tableRef?.current?.toggleRowSelected(row.id, isSelected)
        if (ARRAY.hasArray(row.subRows)) {
          updateChildren(row.subRows, isSelected)
        }
      })
    }
    const isSelected = !row.isSelected

    tableRef?.current?.toggleRowSelected(row.id, isSelected)
    if (ARRAY.hasArray(row.subRows)) {
      updateChildren(row.subRows, isSelected)
    }
  }, [tableRef])

  const columns = useMemo(() => [
    {
      accessor: 'display_name',
      id: 'display_name',
      Cell: (props: any) => <MappingCell {...{ onSelect, enableRowSelect, ...props }} />,
      width: '100%'
    }
  ], [enableRowSelect, onSelect])

  const customGetSubRows: (row: any, relativeIndex: any) => any = (row, relativeIndex) => {
    if (ARRAY.hasArray(row.children)) {
      return row.children.map((child: any) => ({ parent: row, ...child }))
    }
    return []
  }

  const tsgWhitelist = useMemo(() => federationMappingsMap[domain]?.map(federationMapping => federationMapping.tsg_id) || [],
    [federationMappingsMap, domain])

  useEffect(() => {
    tableRef?.current?.flatRows.forEach((row: RowInstance<any>) => {
      if (!row.isSelected && tsgWhitelist.includes(row.original.id)) {
        tableRef?.current?.toggleRowSelected(row.id, true)
      }
    })
  }, [tsgWhitelist, tableRef])

  const expanded = useMemo(() => {

    const reducer: (object: any, item: any, index: any) => any = (object, item, index) => {
      const id = `${item.level ? `${item.level}.` : ''}${index}`
      object[id] = true
      if (ARRAY.hasArray(item.children)) {
        item.children.map((item: any) => ({ ...item, level: id })).reduce(reducer, object)
      }
      return object
    }
    return data.reduce(reducer, {})
  }, [data])

  return (
    <V5TableWrapper className='tw-border tw-border-solid tw-border-gray-300 tw-flex-grow' style={style ? style : {}}>
      <TableProvider
        tableInstanceRef={tableInstanceRef as any}
        initialState={{ expanded } as any}
        columns={columns}
        data={data}
        getSubRows={customGetSubRows}
      >
        <ConnectedTable
          showFooter={false}
          showHeader={false}
          shouldHighlightRow={() => false}
        />
      </TableProvider>
    </V5TableWrapper>
  )
}

export default FederationMappingTable
